import { FacetAction } from "./facet-action";

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener("click", this.onFacetRemove.bind(this));
    }
    
    onFacetRemove() {
        const url = this.generateURLHash() as string;
        const facetAction = new FacetAction();
        facetAction.updateURLHash(url);
        facetAction.fetchPageContent(url);
    }

    generateURLHash() {
        const spanElement = this.querySelector("span");
        return spanElement?.getAttribute("data-remove-url");
    }

}

customElements.define("facet-remove", FacetRemove);
